import React from 'react';
import { Section } from './Section';
import { X } from 'lucide-react';
const failures = [{
  title: 'Apps de listas de tareas',
  desc: 'Solo sirven para documentar tu acumulación de fracasos diarios.'
}, {
  title: 'El multitasking',
  desc: 'Es una mentira biológica que reduce tu coeficiente intelectual en 10 puntos cada vez que saltas de pestaña.'
}, {
  title: 'Despertarse a las 5 AM',
  desc: 'Los consejos no funcionan si tu biología está diseñada para producir en otros horarios.'
}, {
  title: 'Fuerza de voluntad',
  desc: 'Confiar en ella es una estrategia suicida; la voluntad se agota, el sistema no.'
}];
export function WhyItFailedSection() {
  return <Section className="bg-tactical-gray border-y border-tactical-border" data-id="element-136">
      <h2 className="text-3xl md:text-5xl font-bold text-white uppercase text-center mb-10" data-id="element-137">
        Por qué lo que intentaste{' '}
        <span className="text-zinc-500 line-through decoration-red-500" data-id="element-138">
          no funcionó
        </span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-139">
        {failures.map((item, idx) => <div key={idx} className="bg-tactical-dark border border-tactical-border p-6 flex flex-col items-center text-center" data-id="element-140">
            <div className="bg-red-500/10 p-2 shrink-0 mb-4" data-id="element-141">
              <X className="w-6 h-6 text-red-500" data-id="element-142" />
            </div>
            <h3 className="text-xl font-oswald text-white uppercase mb-2 line-through decoration-red-500/50" data-id="element-143">
              {item.title}
            </h3>
            <p className="text-zinc-400" data-id="element-144">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}